// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3hp8C","list":"PatternAutocomplete_list__3Zpe9"};